function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_x0020_1"
}, /*#__PURE__*/React.createElement("metadata", {
  id: "CorelCorpID_0Corel-Layer"
}), /*#__PURE__*/React.createElement("path", {
  d: "M196 618c-64,2 -64,94 0,96l132 0c64,-2 64,-94 0,-96l-132 0zm155 48c0,13 -10,23 -23,23l-132 0c-31,-1 -31,-45 0,-46l132 0c13,0 23,10 23,23l0 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M745 135l-64 0c-17,0 -17,25 0,25l64 0c12,0 21,9 21,21l0 340c0,11 -9,20 -21,20l-584 0c-11,0 -20,-9 -20,-20l0 -17 136 0c75,-3 75,-111 0,-114l-136 0 0 -209c0,-12 9,-21 20,-21l460 0c17,0 17,-25 0,-25l-97 0 0 -55c0,-44 -37,-80 -81,-80l-363 0c-44,0 -80,36 -80,80l0 73c1,17 25,17 25,0l0 -73c0,-30 25,-55 55,-55l363 0c30,0 55,25 55,55l0 55 -18 0 0 -55c0,-20 -17,-36 -37,-36l-68 0c-9,0 -18,6 -21,15l-8 24 -169 0 -8 -24c-3,-9 -11,-15 -21,-15l-68 0c-20,0 -36,16 -36,36l0 707c0,20 16,37 36,37l363 0c20,0 37,-17 37,-37l0 -40c-1,-16 -25,-16 -26,0l0 40c0,6 -5,11 -11,11l-363 0c-6,0 -11,-5 -11,-11l0 -707c0,-6 5,-11 11,-11l66 0 8 24c3,9 12,15 21,15l174 0c9,0 17,-6 20,-15l9 -24 65 0c6,0 11,5 11,11l0 55 -293 0c-25,0 -46,20 -46,46l0 340c0,25 21,46 46,46l293 0 0 121c1,17 25,17 26,0l0 -121 18 0 0 220c0,30 -25,55 -55,55l-363 0c-30,0 -55,-25 -55,-55l0 -573c0,-17 -24,-17 -25,0l0 573c0,44 36,81 80,81l363 0c44,0 81,-37 81,-81l0 -220 221 0c26,0 46,-21 46,-46l0 -340c0,-26 -20,-46 -46,-46l0 0zm-468 281c42,1 42,61 0,62l-136 0 0 -62 136 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M214 201c-12,0 -23,10 -23,23l0 67c0,13 11,23 23,23l105 0c13,0 23,-10 23,-23l0 -67c0,-13 -10,-23 -23,-23l-105 0zm103 88l-100 0 0 -63 100 0 0 63z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M426 244l0 20c1,17 25,17 25,0l0 -20c0,-17 -24,-17 -25,0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M648 277c7,0 13,-6 13,-13l0 -20c-1,-17 -25,-17 -25,0l0 20c0,7 5,13 12,13z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M706 264l0 -20c0,-17 -24,-17 -25,0l0 20c1,17 25,17 25,0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M517 264l0 -20c0,-17 -25,-17 -25,0l0 20c0,17 25,17 25,0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M553 277c7,0 12,-6 12,-13l0 -20c0,-17 -25,-17 -25,0l0 20c0,7 5,13 13,13z"
}), /*#__PURE__*/React.createElement("text", {
  x: 395,
  y: 496
}, "APP"));

var SvgApp = function SvgApp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 791 868",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgApp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/app.df780678.svg";
export { ForwardRef as ReactComponent };